var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-fit-250 items-end gap-2"},_vm._l((_vm.localFilters),function(filter){return _c('wd-filter-input',{key:filter.id,attrs:{"filter":filter},on:{"update-filter":_vm.updateFilterValue}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }